import React from 'react';

import { Button as AntdButton } from 'antd';

import { useBaseFormContext } from 'components/BaseForm/BaseFormContext';

import { FormFilterGardien } from '../../types';

import './FormFooter.less';

interface Props {
  setFilter: (value: Partial<FormFilterGardien>) => void;
}

export function FormFooter({ setFilter }: Props): React.ReactElement {
  const formActions = useBaseFormContext<FormFilterGardien>();

  function resetFilter() {
    formActions.setFieldsValue({
      actionsRequises: undefined,
      classement: undefined,
      statut: undefined,
      natureMiseEnFourriere: undefined,
      dateRangeMiseEnFourriere: undefined,
      motifDeSortie: undefined,
      dateRangeMiseAJour: undefined,
      includeDossiersAnonymises: undefined,
      includeOnlyNotDetruitApresSorti: undefined,
      idMarque: undefined,
      idModele: undefined,
      idJuridictionList: undefined,
    });
  }

  return (
    <div className={'footer_form_gardien'}>
      <AntdButton onClick={resetFilter}>Réinitialiser</AntdButton>

      <AntdButton
        type={'primary'}
        onClick={() => setFilter(formActions.getFieldsValue())}
      >
        Rechercher
      </AntdButton>
    </div>
  );
}
